<ng-container *ngFor="let traits of [item.get_Traits(characterService, get_Creature())]; trackBy:trackByIndex">
    <div class="newrow left-aligned tags" *ngIf="traits.length">
        <app-trait *ngFor="let trait of traits; trackBy:trackByIndex;" [name]="trait" [trait]="get_Traits(trait)[0]">
        </app-trait>
    </div>
</ng-container>
<app-itemContent [item]="item"></app-itemContent>
<!-- Item activities -->
<ng-container *ngIf="item.activities">
    <div class="list-item left-aligned" *ngFor="let activity of item.activities; trackBy:trackByIndex;">
        <header class="spellHeader" *ngIf="activity.name">
            {{activity.name}}
            <app-actionIcons *ngIf="activity.actions" [actionString]="activity.actions">
            </app-actionIcons>
            {{(activity.activationType) ? activity.activationType : ""}}
        </header>
        <div class="newrow left-aligned">
            <app-trait *ngFor="let trait of activity.traits; trackBy:trackByIndex;" [name]="trait"
                [trait]="get_Traits(trait)[0]">
            </app-trait>
            <app-trait *ngFor="let trait of activity.get_ActivationTraits(); trackBy:trackByIndex;" [name]="trait"
                [trait]="get_Traits(trait)[0]"
                [extraDescription]="'(This trait was derived from the action components.)'">
            </app-trait>
        </div>
        <app-activityContent [creature]="creature" [activity]=activity [gain]=activity [allowActivate]="false"
            [cooldown]="activity.get_Cooldown({creature: get_Creature()}, {characterService: characterService, effectsService: effectsService})">
        </app-activityContent>
    </div>
</ng-container>
<!-- Common activities -->
<ng-container *ngIf="item.gainActivities">
    <ng-container *ngFor="let gain of item.gainActivities; trackBy:trackByIndex;">
        <div class="list-item left-aligned" *ngFor="let activity of get_Activities(gain.name); trackBy:trackByIndex;">
            <header class="spellHeader">
                {{activity.name}}
                <app-actionIcons *ngIf="activity.actions" [actionString]="activity.actions">
                </app-actionIcons>
                {{(activity.activationType) ? activity.activationType : ""}}
            </header>
            <div class="newrow left-aligned">
                <app-trait *ngFor="let trait of activity.traits; trackBy:trackByIndex;" [name]="trait"
                    [trait]="get_Traits(trait)[0]">
                </app-trait>
                <app-trait *ngFor="let trait of activity.get_ActivationTraits(); trackBy:trackByIndex;" [name]="trait"
                    [trait]="get_Traits(trait)[0]"
                    [extraDescription]="'(This trait was derived from the action components.)'">
                </app-trait>
            </div>
            <app-activityContent [creature]="creature" [activity]=activity [gain]=gain [allowActivate]="false">
            </app-activityContent>
        </div>
    </ng-container>
</ng-container>
